<template>
  <v-skeleton-loader
    type="avatar"
    max-width="165"
    max-height="165"
    class="circle-card"
  />
</template>

<script>
export default {
  name: 'DonutSkeleton',
}
</script>

<style scoped lang="scss">
.circle-card {
  ::v-deep .v-skeleton-loader__avatar {
    background-color: varFigma(neutral-95-lightest);
    width: 165px;
    height: 165px;
  }
}
</style>
